import React, { useEffect, useState } from 'react';
import SGMSClient from '../../../js/SGMSClient';
import { store } from '../../../stores/store';
import './Leaderboard.css';


// L89TA5
// SRARNV

const Leaderboard = () => {

  const [error, setError] = useState(false);
  const [key, setKey] = useState("indT47");
  const [loading, setLoading] = useState(true);
  const [highScores, setHighScores] = useState(null);
  const [authorizedUsers, setAuthorizedUsers] = useState(null);
  let scoreConfig = SGMSClient.currentMeeting.Config.Scores

  useEffect(() => {

    SGMSClient.meetingGetFields(["AuthorizedUsersId"])
    .then(data => {
      console.log("data", data)
      setAuthorizedUsers(data.AuthorizedUsersId)
    })
    .then(() => SGMSClient.userMeetingGetCustomScores())
    .then(customScores => {
      setLoading(false)
      if(customScores) setHighScores(customScores.highscores)

    })
    .catch((err) => {
      setError(true)
    } )

  }, []);

  function getBestScore(scores, _key) {
    scores.sort((a, b) => {
      if(a[_key] > b[_key] ) return -1
      if(a[_key] < b[_key] ) return 1
      return 0
    })
    return scores[0]
  }



  let rows = []
  if(highScores) {
    for(let userId in highScores) {
      let userinfo = authorizedUsers[userId]
      let pseudo = userinfo && userinfo.Pseudo
      let userScores = highScores[userId]
      let scores = getBestScore(userScores, key)

      // pas de log des users non authentifiés
      if(pseudo !== null) {
        let row = { pseudo }
        scoreConfig.forEach(({id}) => row[id] = scores[id])
        rows.push(row)
      }
    }
  }

  rows = rows.sort((a, b) => {
    if(a[key] < b[key] ) return 1
    if(a[key] > b[key] ) return -1
    return 0
  })

  return (
    <div className="Leaderboard">

      {error && <div>{store.t("meeting_datas_error")}</div>}
      {loading && <div>{store.t("loading")}</div>}
      {!loading && !highScores && <div>{store.t("scores_no_data")}</div>}
      {highScores &&
      <div>

        {SGMSClient.currentUser && SGMSClient.currentUser.UserLogin.indexOf("anonymous_") === 0 &&
        <div>{store.t('connection_incitation')}</div>}


        <table>
          <thead>
            <tr>
              <th>Pseudo</th>
              {scoreConfig.map(score => (
                <th key={score.id} className={score.id}>
                  <span onClick={()=>{setKey(score.id)}}>{score.name}</span>
                </th>))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, index) => (
              <tr key={index}>
                {Object.keys(r).map(id => <td key={id}>{r[id]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>}

    </div>
  );
};

export default Leaderboard;
